import styled from 'styled-components';

export const Container = styled.div`
  height: var(--height-body-without-header);
  max-height: var(--height-body-without-header);
  display: flex;
  flex-direction: column;
`;

export const Subtitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  color: #898b8e;
`;

export const MainWrapper = styled.div`
  padding: 32px;
  height: 100%;
  overflow-y: auto;

  list {
    list-style: none;
    padding: 0;
    margin-top: 29px;
  }
`;

export const ListWrapper = styled.div`
  margin-top: 29px;
`;

export const ItemWrapper = styled.li`
  margin-bottom: 19px;
  height: 80px;
  width: 100%;

  border-radius: 8px;
  list-style: none;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: auto;
`;
